import { render, staticRenderFns } from "./MySwipe.vue?vue&type=template&id=7f1b322b&scoped=true"
import script from "./MySwipe.vue?vue&type=script&lang=js"
export * from "./MySwipe.vue?vue&type=script&lang=js"
import style0 from "./MySwipe.vue?vue&type=style&index=0&id=7f1b322b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1b322b",
  null
  
)

export default component.exports